import template from './contact-list.pug';



export const ContactListComponent = {
  template,
  bindings: {
    filter: '<',
    isModal: '<?',
    onCheck: '&?'
  },
  controller: class ContactListComponent {
    constructor(Contact, User, RecordGroup, Account, Project, Signal, LocalStorage, MediaQuery, Hotkeys, $stateParams, $state, $auth, $async, $log, $scope) {
      'ngInject';
      this.$stateParams = $stateParams;
      this.$state = $state;
      this.$scope = $scope;
      this.Contact = Contact;
      this.Hotkeys = Hotkeys;
      this.Project = Project;
      this.User = User;
      this.Signal = Signal;
      this.RecordGroup = RecordGroup;
      this.$log = $log;
      this.$auth = $auth;
      this.getUser = $async(this.getUser.bind(this));
      this.LocalStorage = LocalStorage;
      this.getAccountStats = $async(this.getAccountStats.bind(this));
      this.getGroups = $async(this.getGroups.bind(this));
      this.createNewContact = $async(this.createNewContact.bind(this));
      this.Account = Account;
      this.totalRecords = 1;
      this.groups = [];
      this.newGroup = false;

      this.isMobile = MediaQuery.isMobileDevice();
      this.sidebarOpen = !this.isMobile;

      $scope.$on('mediaChange', function(event, data) {
        $scope.isMobile = data.isMobile;
        $scope.sidebarOpen = !data.isMobile;
      });
    }

    registerEscAction() {
      const esc_hotkey = this.Hotkeys.createHotkey({
        key: ['escape'],
        callback: () => {
          this.sidebarOpen = false;
        },
      });
      this.Hotkeys.registerHotkey(esc_hotkey);
    }

    addGroup() {
      // Create list of default emojies for business cards
      this.newGroup = {
        emoji: this.RecordGroup.getRandomEmoji(),
        name: '',
      };
    }

    async createNewContact() {
      try {
        const contact = await this.Contact.new();
        if (contact && contact.id) {
          this.$state.go('main.contacts.show', { id: contact.id });
        }
      } catch (e) {
        this.$log.error(e);
      }
    }

    async createGroup() {
      if (!this.newGroup.name.length) {
        this.newGroup = false;
        return;
      }
      try {
        const group = await this.RecordGroup.create({
          name: this.newGroup.name,
          emoji: this.newGroup.emoji,
          module: 'contact'
        });
        this.newGroup = false;
        this.groups.unshift(group);
        this.selectGroup(group);
      } catch (err) {
        this.$log.log(err);
      }
    }

    bigNumberToShortString(number) {
      if (number > 1000000) {
        return `${Math.round(number / 1000000)}M`;
      } else if (number > 1000) {
        return `${Math.round(number / 1000)}K`;
      }
      return number;
    }

    selectGroup(group) {
      this.selectedGroup = group;
      this.RecordGroup.setLastGroupId('contacts', group.id);
      this.$state.go('main.contacts.list', { page: 1, groupId: group.id });
    }

    async $onInit() {
      this.getAccountStats();

      this.filter = angular.copy(this.filter);
      if (this.$stateParams.user_id) {
        this.getUser(this.$stateParams.user_id);
      }

      await this.getGroups();
      if (this.filter.group_id) {
        this.selectedGroup = this.groups.find(group => group.id === parseInt(this.filter.group_id));
      }

      if (!this.selectedGroup) {
        const lastGroupId = this.RecordGroup.returnLastGroupId('contacts');
        if (lastGroupId) {
          const group = this.groups.find(group => group.id === parseInt(lastGroupId));
          this.selectGroup(group);
        } else {
          this.selectGroup(this.groups[0]);
        }
      }
      this.Signal.listen('recordGroupUpdated', this.$scope, (updatedGroup) => {
        this.groups = this.groups.map(group => {
          if (group.id === updatedGroup.id) {
            return updatedGroup;
          }
          return group;
        });
      });

      this.registerEscAction();

      this.Signal.listen('toggleSideBar', this.$scope, () => {
        this.sidebarOpen = !this.sidebarOpen;
      });
    }

    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    }

    importContacts() {
      this.$state.go('main.contacts.import', { groupId: this.selectedGroup.id });
    }

    async getUser(user_id) {
      try {
        this.user = await this.User.cardInfo(user_id);
      } catch (e) {
        this.$log.log(e);
      }
    }

    async getGroups() {
      try {
        this.groups = await this.RecordGroup.getList(
          'contact',
          {
            project_id: this.Project.currentProjectId()
          }
        );

      } catch (e) {
        this.$log.log(e);
      }
    }

    async getAccountStats() {
      try {
        this.totalRecords = await this.Contact.count();
      } catch (e) {
        this.$log.log(e);
      }
    }

    closeUserPortfolioWidget() {
      this.$state.go('main.contacts.list', { page: 1 });
    }

    applyFilterAndResetPage({ filter }) {
      this.applyFilter(filter);
      this.updatePage({ page: filter.page || 1 });
    }

    updatePage({ page, searchId,  statusId }) {
      searchId = searchId || this.$stateParams.searchId;
      this.LocalStorage.set('contact', 'list_page', page);

      this.$state.go('.', { page, searchId, statusId });
      this.filter.page = page;
      this.$onInit();
    }

    applyFilter(filter) {
      if (!{}.hasOwnProperty.call(filter, 'user_id') && this.$stateParams.user_id) {
        this.filter = { ...filter, user_id: this.$stateParams.user_id } || {};
      } else if (this.$stateParams.customFieldId && this.$stateParams.destinationId && this.$stateParams.destinationType) {
        this.filter = {
          ...filter,
          connected_record: {
            custom_field_id: this.$stateParams.customFieldId,
            destination_id: this.$stateParams.destinationId,
            destination_type: this.$stateParams.destinationType
          }
        } || {};
      } else {
        this.filter = filter || {};
      }
    }

    doCheck({ checkedIds }) {
      if (this.onCheck) {
        this.onCheck({
          $event: { checkedIds }
        });
      }
    }

  }
};
